import * as React from 'react'

const RainPartiallyCloudyIcon = props => (
  <svg
    width="17"
    height="15"
    viewBox="0 0 17 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M9.21248 2.04374C9.21248 2.97968 8.45252 3.74764 7.50858 3.74764C6.72463 3.74764 6.06867 3.21967 5.86868 2.49971C5.82869 2.35572 5.80469 2.20373 5.80469 2.04374C5.80469 1.0998 6.56464 0.339844 7.50858 0.339844C7.70057 0.339844 7.88456 0.371842 8.05255 0.427839C8.73251 0.659825 9.21248 1.29179 9.21248 2.04374Z"
      fill="#EDEDED"
    />
    <path
      opacity="0.5"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M8.32435 1.37985C7.88437 1.95581 7.01243 2.2198 6.36447 2.48378C6.34847 2.49178 6.33247 2.49178 6.31647 2.49978C6.06848 2.55577 5.8285 2.36379 5.8125 2.1078C5.8125 2.03581 5.8125 1.96381 5.8205 1.88382C5.8925 1.06787 6.54046 0.411906 7.35641 0.33991C7.60439 0.315912 7.84438 0.34791 8.06836 0.419905C8.36434 0.699888 8.57233 1.05987 8.32435 1.37985Z"
      fill="white"
    />
    <path
      opacity="0.9"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M7.36383 0.556641C7.29983 0.556641 7.22783 0.56464 7.17184 0.588638C7.05984 0.628636 6.95585 0.676633 6.85986 0.748628C6.77986 0.812624 6.70787 0.908618 6.68387 1.00461C6.67587 1.04461 6.67587 1.10061 6.71587 1.13261C6.79586 1.2046 6.95585 1.1486 7.03585 1.10861C7.09984 1.06861 7.15584 1.01261 7.22783 0.972615C7.29983 0.924618 7.37182 0.892619 7.45182 0.860621C7.48382 0.852622 7.51582 0.836623 7.53982 0.812625C7.57981 0.772627 7.58781 0.700632 7.56381 0.652635C7.54781 0.612637 7.49982 0.580639 7.45982 0.572639C7.41982 0.56464 7.38782 0.556641 7.36383 0.556641Z"
      fill="white"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M16.3966 4.88347C16.3806 4.10752 15.9726 3.42756 15.3646 3.01959C15.0126 2.7876 14.5967 2.64361 14.1567 2.63561C13.2607 2.61161 12.4768 3.09958 12.0688 3.82754C11.8528 4.21952 11.5169 4.5235 11.1169 4.69149C10.8849 4.78748 10.6369 4.84348 10.3809 4.84348H10.3249C9.66097 4.84348 9.125 5.37944 9.125 6.0434C9.125 6.37138 9.26099 6.67537 9.47698 6.89135C9.69296 7.10734 9.99695 7.24333 10.3249 7.24333H14.0927C15.3806 7.25133 16.4286 6.1874 16.3966 4.88347Z"
      fill="#EDEDED"
    />
    <path
      opacity="0.5"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M15.4605 3.95553C15.3005 4.17952 14.9885 4.21152 14.7165 4.23551C14.2685 4.27551 13.7806 4.33151 13.4606 4.65149C13.2766 4.83548 13.1726 5.09146 13.0046 5.29945C12.8046 5.55543 12.5166 5.74742 12.1887 5.78742C11.8687 5.82742 11.5167 5.69943 11.3247 5.43544C11.3007 5.40344 11.2847 5.37144 11.2607 5.32345C11.1247 5.01947 11.2287 4.66749 11.5007 4.4675C11.7247 4.29951 11.9167 4.08352 12.0607 3.82754C12.4606 3.09958 13.2446 2.61161 14.1485 2.63561C14.4605 2.64361 14.7565 2.71561 15.0205 2.8356C15.2925 2.95559 15.4925 3.20358 15.5485 3.49156C15.5805 3.65955 15.5645 3.81954 15.4605 3.95553Z"
      fill="white"
    />
    <path
      opacity="0.9"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M14.4755 3.01291C14.3155 2.85292 13.8915 2.88492 13.7235 2.94892C13.6195 2.98891 13.5075 3.06091 13.4835 3.1729C13.4595 3.2849 13.5235 3.40489 13.6355 3.42889C13.7555 3.45289 13.8675 3.38089 13.9875 3.34889C14.1155 3.31689 14.2515 3.3089 14.3875 3.3089C14.4195 3.3089 14.4515 3.3089 14.4755 3.2929C14.5875 3.2609 14.5395 3.08491 14.4755 3.01291Z"
      fill="white"
    />
    <path
      opacity="0.9"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M13.3012 3.62059C13.3412 3.58859 13.3652 3.5406 13.3492 3.4926C13.3412 3.4526 13.3172 3.42061 13.2852 3.39661C13.2692 3.38061 13.2452 3.36461 13.2213 3.34861C13.1173 3.30861 12.9813 3.41261 12.9733 3.5166C12.9653 3.58859 13.0373 3.66859 13.1013 3.69259C13.1733 3.70859 13.2452 3.66859 13.3012 3.62059C13.3012 3.62859 13.3012 3.62859 13.3012 3.62059Z"
      fill="white"
    />
    <path
      opacity="0.2"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M14.1164 6.85265C14.3804 6.93265 14.8123 6.81265 14.9723 6.72466C15.2363 6.58067 15.5643 6.26869 15.5643 5.94071C15.5643 5.76472 15.4443 5.58873 15.2763 5.51673C15.1323 5.45274 14.9643 5.47673 14.8123 5.53273C14.6603 5.58873 14.5404 5.69272 14.4204 5.78872C14.2684 5.91671 14.1164 6.0447 14.0124 6.22069C13.9564 6.31668 13.9164 6.42868 13.9004 6.54867C13.9004 6.72466 13.9804 6.81265 14.1164 6.85265Z"
      fill="#CBBEBB"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M12.7552 5.71628C12.7552 7.55617 11.2673 9.04408 9.4274 9.04408C7.58752 9.04408 6.09961 7.55617 6.09961 5.71628C6.09961 5.31631 6.1716 4.94033 6.2996 4.58835C6.76357 3.30843 7.98749 2.39648 9.4274 2.39648C9.89138 2.39648 10.3393 2.49248 10.7393 2.66847C11.9313 3.17244 12.7552 4.34837 12.7552 5.71628Z"
      fill="#FFC34A"
    />
    <path
      opacity="0.6"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M9.83654 4.75672C9.54856 4.72472 9.26857 4.66872 8.98059 4.67672C8.50862 4.69272 8.21264 4.9407 7.99665 5.34068C7.80466 5.68466 7.66067 6.10863 7.2607 6.25262C7.08471 6.31662 6.87672 6.30062 6.74073 6.17263C6.66873 6.10063 6.62074 6.00464 6.58074 5.91664C6.58074 5.90864 6.58074 5.90864 6.57274 5.90064C6.21276 5.0207 6.42075 4.00476 7.10071 3.3408C7.70067 2.74884 8.52462 2.38086 9.43656 2.38086C9.69255 2.38086 9.93253 2.40486 10.1725 2.46085C10.7005 2.58085 11.1165 2.99682 11.1965 3.53279C11.1965 3.55679 11.2045 3.58079 11.2045 3.59679C11.2845 4.42874 10.5725 4.83671 9.83654 4.75672Z"
      fill="#FFE332"
    />
    <path
      opacity="0.3"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M7.6686 3.71484C7.61261 3.71484 7.56461 3.71484 7.50861 3.73084C7.23663 3.80284 7.00464 4.01882 6.91665 4.28281C6.86065 4.4508 6.86865 4.67478 7.06864 4.74678C7.10864 4.76278 7.14863 4.76278 7.18863 4.76278C7.34862 4.75478 7.46861 4.65879 7.58861 4.57079L7.98058 4.27481C8.03658 4.23481 8.08458 4.17882 8.10858 4.11482C8.16457 3.96283 8.08458 3.85083 7.97258 3.78684C7.90059 3.74684 7.82859 3.73084 7.7486 3.72284L7.6686 3.71484Z"
      fill="white"
    />
    <path
      opacity="0.15"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M7.76493 7.4437C7.74093 7.5717 7.75693 7.70769 7.80493 7.83568C8.11691 8.55564 9.28484 8.92362 9.8368 8.28365C10.0688 8.01167 10.1008 7.61969 9.8928 7.33171C9.80481 7.21172 9.66882 7.12372 9.52482 7.05973C9.08485 6.85174 8.3329 6.67575 7.94892 7.07573C7.86093 7.17172 7.79693 7.30771 7.76493 7.4437Z"
      fill="white"
    />
    <path
      opacity="0.15"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M8.55541 7.92266C8.53141 8.01065 8.53941 8.10665 8.60341 8.18664C8.66741 8.26664 8.7634 8.31463 8.85939 8.34663C8.96339 8.37863 9.08338 8.38663 9.16338 8.32263C9.32337 8.19464 9.27537 7.90666 9.09938 7.81866C9.04338 7.78666 8.97139 7.77866 8.90739 7.77066C8.7634 7.74667 8.60341 7.76267 8.55541 7.92266Z"
      fill="white"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M9.44215 5.71522C9.44215 5.72322 9.43415 5.73122 9.42615 5.73122C9.41815 5.73122 9.41016 5.72322 9.41016 5.71522C9.41016 5.71522 9.41016 5.71522 9.41016 5.70722C9.41016 5.69922 9.41815 5.69922 9.42615 5.69922C9.42615 5.69922 9.42615 5.69922 9.43415 5.69922C9.44215 5.70722 9.44215 5.70722 9.44215 5.71522Z"
      fill="black"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M13.1957 8.9955C13.2037 9.29949 13.1077 9.59547 12.9477 9.84345C12.6917 10.2354 12.2438 10.5074 11.7078 10.5074H1.92439C1.34043 10.5074 0.804459 10.1714 0.572473 9.62747C0.484479 9.42748 0.436482 9.21149 0.412483 8.9955C0.396484 8.85951 0.396484 8.71552 0.396484 8.57953C0.444481 7.4436 1.18044 6.29967 2.28437 6.45166C2.28437 6.45166 2.28437 6.45166 2.29237 6.45166C2.27637 6.29167 2.27637 6.12368 2.30037 5.97169C2.56435 3.83582 5.86015 2.5719 7.31606 4.95575C7.43605 5.14774 7.54005 5.36373 7.62804 5.60371C9.09195 4.1958 11.6438 5.65171 11.1638 7.57959C10.8438 8.86751 10.8438 8.86751 11.1638 7.57959C12.0198 7.4596 12.6037 7.74758 12.9317 8.18755C13.1077 8.44354 13.1957 8.72352 13.1957 8.9955Z"
      fill="#EDEDED"
    />
    <path
      opacity="0.5"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M7.39472 6.19577C7.37872 6.45175 7.30673 6.74773 7.07474 6.85973C6.87476 6.95572 6.63477 6.86773 6.45078 6.74774C6.26679 6.62774 6.0988 6.46775 5.88282 6.40376C5.45884 6.27576 5.03487 6.55575 4.70689 6.85973C4.38691 7.15571 4.05893 7.51569 3.62695 7.57169C3.23498 7.62768 2.835 7.41969 2.59502 7.10771C2.44303 6.91572 2.34703 6.69174 2.28304 6.45975C2.28304 6.45975 2.28304 6.45975 2.29104 6.45975C2.06705 4.0519 5.74682 2.412 7.30673 4.96384C7.39472 5.36382 7.42672 5.7798 7.39472 6.19577Z"
      fill="white"
    />
    <path
      opacity="0.5"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M3.62912 7.90677C3.39713 8.12276 3.01316 8.00277 2.73317 8.13876C2.3572 8.31475 2.3092 8.83471 2.01322 9.1307C1.70924 9.44268 1.16527 9.41868 0.821291 9.1627L0.813291 9.1547C0.50131 8.92271 0.373319 8.51473 0.445314 8.13076C0.637303 7.15482 1.31726 6.30687 2.2772 6.44286C2.2772 6.44286 2.2772 6.44286 2.2852 6.44286C2.2692 6.27487 2.2692 6.11488 2.2932 5.96289C2.86117 6.06688 3.38913 6.43486 3.64512 6.96283C3.71711 7.10682 3.76511 7.25881 3.78111 7.4188C3.79711 7.60279 3.75711 7.78678 3.62912 7.90677Z"
      fill="white"
    />
    <path
      opacity="0.9"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M5.43536 4.19507C5.37137 4.07507 5.25137 4.00308 5.11538 4.00308C4.7874 3.99508 4.45142 4.02708 4.16344 4.18707C4.07545 4.23506 3.98745 4.30706 3.95545 4.40305C3.93945 4.44305 3.93945 4.49105 3.93945 4.53904C3.93945 4.63504 3.96345 4.73903 4.02745 4.81103C4.09144 4.88302 4.18744 4.90702 4.27543 4.90702C4.37143 4.89902 4.45142 4.86702 4.53142 4.81103C4.58741 4.77103 4.63541 4.72303 4.69141 4.68304C4.7954 4.61104 4.91539 4.56304 5.03539 4.53904C5.13138 4.52304 5.24337 4.51505 5.32337 4.45905C5.42736 4.40305 5.48336 4.28306 5.43536 4.19507Z"
      fill="white"
    />
    <path
      opacity="0.9"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M3.54868 4.93945C3.49269 4.93945 3.42869 4.95545 3.38869 4.98745C3.3007 5.06745 3.22071 5.16344 3.18071 5.27543C3.14871 5.33943 3.13271 5.41942 3.14071 5.48342C3.14871 5.54742 3.18871 5.62741 3.2527 5.65941C3.3007 5.68341 3.3647 5.68341 3.41269 5.67541C3.59668 5.64341 3.75667 5.50742 3.82067 5.33943C3.84467 5.26743 3.86067 5.19544 3.83667 5.12344C3.81267 5.01945 3.71667 4.95545 3.61268 4.94745L3.54868 4.93945Z"
      fill="white"
    />
    <path
      opacity="0.9"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M1.92466 6.82672C1.66067 6.86672 1.41269 7.00271 1.2527 7.2187C1.10871 7.40269 1.01271 7.62667 0.972716 7.85866C0.964716 7.93065 0.964716 8.01065 1.01271 8.05864C1.04471 8.08264 1.08471 8.09064 1.13271 8.09064C1.1967 8.09864 1.2767 8.09864 1.33269 8.06664C1.42869 8.01865 1.47669 7.89866 1.51668 7.79466C1.59668 7.57868 1.73267 7.36269 1.94866 7.29069C1.96465 7.28269 1.97265 7.28269 1.98865 7.28269C2.06865 7.25869 2.13264 7.2107 2.17264 7.1387C2.26064 6.95471 2.07665 6.80272 1.92466 6.82672Z"
      fill="white"
    />
    <path
      opacity="0.9"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M7.94738 5.74732C7.89138 5.79532 7.83539 5.84332 7.80339 5.90731C7.77139 5.96331 7.76339 6.0353 7.78739 6.0993C7.84339 6.25129 8.01938 6.25929 8.13937 6.1953C8.24336 6.1393 8.31536 6.0513 8.41135 5.97931C8.55534 5.86732 8.73933 5.80332 8.91532 5.75532C8.97132 5.73932 9.03532 5.72332 9.08331 5.68333C9.13131 5.64333 9.16331 5.57933 9.13131 5.52334C9.10731 5.46734 9.03532 5.44334 8.97132 5.44334C8.76333 5.41934 8.55534 5.45134 8.36336 5.53134L8.27536 5.57133C8.15537 5.61933 8.04338 5.67533 7.94738 5.74732Z"
      fill="white"
    />
    <path
      opacity="0.2"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M11.2752 8.17908C11.4192 8.17108 11.5552 8.17108 11.6912 8.18708C11.9312 8.21108 12.1712 8.30707 12.3312 8.49106C12.7551 8.97903 12.4272 9.72299 11.8592 9.89098C11.6192 9.96297 11.3632 9.96297 11.1152 9.95497C10.7873 9.93898 10.4433 9.89898 10.1633 9.71499C9.78732 9.467 9.65933 8.89904 10.0033 8.57106C10.1393 8.44307 10.3233 8.37907 10.4993 8.32308C10.7393 8.25108 11.0112 8.19508 11.2752 8.17908Z"
      fill="#CBBEBB"
    />
    <path
      opacity="0.2"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M8.65159 8.9475C8.5236 9.01149 8.40361 9.09949 8.34761 9.18748C8.29162 9.26748 8.30761 9.36347 8.33961 9.45146C8.36361 9.51546 8.39561 9.57946 8.44361 9.62745C8.5876 9.76345 8.93158 9.76345 9.09157 9.65945C9.22756 9.57146 9.33955 9.36347 9.31555 9.19548C9.29955 9.08349 9.20356 8.96349 9.10757 8.9075C8.98757 8.8435 8.81158 8.8755 8.65159 8.9475Z"
      fill="#CBBEBB"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M3.57092 13.2262C3.53892 13.2822 3.51492 13.3382 3.48292 13.3862C3.15494 13.8981 2.68297 14.0021 2.275 13.8021C2.01101 13.6661 1.82702 13.4342 1.79503 13.1302C1.77103 12.9222 1.81902 12.6822 1.94702 12.4182C2.147 12.0182 2.62697 11.8183 2.97095 11.7223C3.19494 11.6583 3.42693 11.7783 3.50692 11.9943C3.64291 12.3222 3.7709 12.8262 3.57092 13.2262Z"
      fill="#75BEEA"
    />
    <path
      opacity="0.2"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M3.33203 13.3157C3.42002 13.3317 3.45202 13.4357 3.39602 13.5077C3.07604 13.9156 2.65207 13.9796 2.27609 13.7956C2.03611 13.6757 1.86812 13.4837 1.81212 13.2277C1.79612 13.1637 1.83612 13.0997 1.90012 13.0837C2.1801 13.0117 2.38809 13.2997 2.64407 13.3957C2.90806 13.4917 3.08404 13.2837 3.33203 13.3157Z"
      fill="white"
    />
    <path
      opacity="0.5"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M2.54853 12.1387C2.51654 12.1387 2.48454 12.1467 2.45254 12.1627C2.34855 12.2187 2.24455 12.3227 2.21255 12.4427C2.18056 12.5706 2.29255 12.7226 2.42054 12.6346C2.52454 12.5626 2.70052 12.4267 2.69252 12.2747C2.70052 12.1787 2.62853 12.1387 2.54853 12.1387Z"
      fill="white"
    />
    <path
      opacity="0.5"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M2.25152 13.3875C2.23552 13.3555 2.21152 13.3155 2.17952 13.2995C2.17152 13.2995 2.17152 13.2915 2.16352 13.2915C2.12352 13.2675 2.07553 13.2595 2.04353 13.2995C2.01153 13.3395 2.01153 13.3955 2.04353 13.4355C2.05953 13.4675 2.08353 13.4835 2.11552 13.5075C2.12352 13.5155 2.13152 13.5155 2.13952 13.5235C2.14752 13.5235 2.16352 13.5235 2.17152 13.5235C2.20352 13.5235 2.24352 13.5075 2.25952 13.4835C2.27552 13.4595 2.26752 13.4275 2.25952 13.4035C2.25952 13.3955 2.25952 13.3875 2.25152 13.3875Z"
      fill="white"
    />
    <path
      opacity="0.5"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M2.44464 13.4586C2.47664 13.4506 2.50863 13.4586 2.53263 13.4586C2.54863 13.4586 2.56463 13.4666 2.58063 13.4746C2.59663 13.4906 2.60463 13.5146 2.60463 13.5306C2.60463 13.5626 2.58863 13.5786 2.56463 13.5866C2.52463 13.5946 2.46864 13.6106 2.42864 13.5786C2.38864 13.5466 2.38864 13.4746 2.44464 13.4586Z"
      fill="white"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M6.97172 13.5387C6.94773 13.5787 6.93173 13.6187 6.90773 13.6587C6.66774 14.0347 6.32376 14.1067 6.02778 13.9627C5.83579 13.8667 5.6998 13.6907 5.6758 13.4747C5.6598 13.3227 5.6918 13.1467 5.7878 12.9547C5.93179 12.6668 6.28377 12.5148 6.53175 12.4428C6.69174 12.3948 6.85973 12.4828 6.92373 12.6428C7.02772 12.8827 7.11572 13.2507 6.97172 13.5387Z"
      fill="#75BEEA"
    />
    <path
      opacity="0.2"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M6.79685 13.6107C6.86085 13.6187 6.88485 13.6987 6.84485 13.7546C6.61287 14.0506 6.30088 14.0986 6.0289 13.9626C5.85291 13.8746 5.73292 13.7307 5.69292 13.5467C5.68492 13.4987 5.70892 13.4587 5.75692 13.4427C5.96491 13.3947 6.1089 13.6027 6.30089 13.6667C6.48487 13.7307 6.62087 13.5787 6.79685 13.6107Z"
      fill="white"
    />
    <path
      opacity="0.5"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M6.22885 12.748C6.20485 12.748 6.18085 12.756 6.15685 12.764C6.07686 12.804 6.00486 12.884 5.98086 12.964C5.95686 13.06 6.03686 13.164 6.13285 13.1C6.21285 13.044 6.33284 12.948 6.33284 12.836C6.33284 12.78 6.28484 12.748 6.22885 12.748Z"
      fill="white"
    />
    <path
      opacity="0.5"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M6.07684 13.6922C6.06084 13.6602 6.03685 13.6202 6.00485 13.6042C5.99685 13.5962 5.99685 13.5962 5.98885 13.5962C5.94885 13.5722 5.90085 13.5642 5.86886 13.6042C5.83686 13.6442 5.83686 13.7002 5.86086 13.7402C5.87686 13.7722 5.90885 13.7962 5.93285 13.8122C5.94085 13.8202 5.94885 13.8202 5.95685 13.8282C5.96485 13.8282 5.98085 13.8282 5.98885 13.8282C6.02085 13.8282 6.06084 13.8122 6.07684 13.7882C6.09284 13.7642 6.08484 13.7322 6.07684 13.7082C6.08484 13.7002 6.07684 13.6922 6.07684 13.6922Z"
      fill="white"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M10.8912 13.2262C10.8592 13.2822 10.8352 13.3382 10.8032 13.3862C10.4753 13.8981 10.0033 14.0021 9.59531 13.8021C9.33132 13.6661 9.14734 13.4342 9.11534 13.1302C9.09134 12.9222 9.13934 12.6822 9.26733 12.4182C9.46732 12.0182 9.94729 11.8183 10.2913 11.7223C10.5153 11.6583 10.7472 11.7783 10.8272 11.9943C10.9632 12.3222 11.0912 12.8262 10.8912 13.2262Z"
      fill="#75BEEA"
    />
    <path
      opacity="0.2"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M10.6522 13.3157C10.7402 13.3317 10.7801 13.4357 10.7242 13.5077C10.4042 13.9156 9.9802 13.9796 9.60422 13.7956C9.36423 13.6757 9.19624 13.4837 9.14025 13.2277C9.12425 13.1637 9.16425 13.0997 9.22824 13.0837C9.50822 13.0117 9.71621 13.2997 9.9722 13.3957C10.2282 13.4917 10.4042 13.2837 10.6522 13.3157Z"
      fill="white"
    />
    <path
      opacity="0.5"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M9.87666 12.1387C9.84466 12.1387 9.81266 12.1467 9.78066 12.1627C9.67667 12.2187 9.57268 12.3227 9.54068 12.4427C9.50868 12.5706 9.62067 12.7226 9.74867 12.6346C9.85266 12.5626 10.0286 12.4267 10.0206 12.2747C10.0206 12.1787 9.94866 12.1387 9.87666 12.1387Z"
      fill="white"
    />
    <path
      opacity="0.5"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M9.57964 13.3875C9.56364 13.3555 9.53964 13.3155 9.50764 13.2995C9.49965 13.2995 9.49965 13.2915 9.49165 13.2915C9.45165 13.2675 9.40365 13.2595 9.37165 13.2995C9.33966 13.3395 9.33966 13.3955 9.37165 13.4355C9.38765 13.4675 9.41165 13.4835 9.44365 13.5075C9.45165 13.5155 9.45965 13.5155 9.46765 13.5235C9.47565 13.5235 9.49165 13.5235 9.49965 13.5235C9.53164 13.5235 9.57164 13.5075 9.58764 13.4835C9.60364 13.4595 9.59564 13.4275 9.58764 13.4035C9.57964 13.3955 9.57964 13.3875 9.57964 13.3875Z"
      fill="white"
    />
    <path
      opacity="0.5"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M9.763 13.4586C9.787 13.4506 9.827 13.4586 9.85099 13.4586C9.86699 13.4586 9.88299 13.4666 9.89899 13.4746C9.91499 13.4906 9.92299 13.5146 9.92299 13.5306C9.92299 13.5626 9.90699 13.5786 9.88299 13.5866C9.84299 13.5946 9.787 13.6106 9.747 13.5786C9.707 13.5466 9.707 13.4746 9.763 13.4586Z"
      fill="white"
    />
  </svg>
)

export default RainPartiallyCloudyIcon
